export const siteName = 'Utopicus';
export const pageTitleFallback = 'Utopicus';
export const pageDescriptionFallback = 'Utopicus';
export const ogUrlFallback = '';

export function getFullPageTitle<T extends string>(title?: T) {
  return title || pageTitleFallback;
}

export function getFullPageDescription<T extends string>(description?: T) {
  return description || pageDescriptionFallback;
}

export function renderMetadataTemplate<ParamsType extends Record<string, unknown>>(
  template: string,
  params: ParamsType
) {
  let result = template;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replaceAll(`{{${key}}}`, value as string);
  });
  return result;
}

export function renderMetadataTemplateMap<
  MapKeyType extends string,
  ParamsType extends Record<string, unknown>
>(templateMap: Record<MapKeyType, string>, params: ParamsType) {
  return Object.entries(templateMap).reduce(
    (acc, [key, value]) => {
      acc[key as MapKeyType] = renderMetadataTemplate(value as string, params);
      return acc;
    },
    {} as Record<MapKeyType, string>
  );
}
